<template>
  <span>
    <transition :name="myName" mode="out-in">
      <slot></slot>
    </transition>
  </span>
</template>
<style lang="scss">
.left-enter-active,
.left-leave-active {
  transition: all 0.3s;
}
.left-enter, .left-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-50px)
}

.up-enter-active,
.up-leave-active {
  transition: all 0.3s;
}
.up-enter, .up-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px)
}

.opacity-enter-active,
.opacity-leave-active {
  transition: all 0.3s;
}
.opacity-enter, .opacity-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}



</style>



<script>
export default {
  name: "Mytransition",
  props: {
    myName:"",
  }
};
</script>